<template>
    <a-spin :spinning="loading">
        <CancelPlanModal
            v-if="cancelPlanModal"
            @confirm="unsubscribe(cancelPlanModal)"
            @reject="cancelPlanModal = false"
            :planPeriod="localPeriod"
            :loading="loadingUnsubscribe"
        />
        <CreatePlanModal
            v-if="subscribePlanModal"
            @confirm="subscribe(subscribePlanModal)"
            @reject="subscribePlanModal = false"
            :planPeriod="localPeriod"
            :loading="loadingSubscribe"
        />
        <CreditCardNeeded @close="creditCardRequired = null" v-if="creditCardRequired" />
        <DowngradeWarn v-if="showWarn" @close="showWarn = null" @forward="forwardPage">
            <template v-if="showWarn == 'supsis'">
                {{ $t("billing.packageCanNotDownSupsis") }}
            </template>
            <template v-else-if="showWarn == 'whatsapp'">
                {{ $t("billing.packageCanNotDownWp") }}
            </template>
            <template v-else-if="showWarn == 'whatsapp-business'">
                {{ $t("billing.packageCanNotDownWPBussiness") }}
            </template>
        </DowngradeWarn>
        <ExtraPlanModal
            v-if="chatbotExtraPackageModal"
            @confirm="subscribeExtra"
            @close="chatbotExtraPackageModal = false"
        />
        <div class="billing-plans">
            <div class="title">
                <div class="title-plan">
                    <div class="title-plan-icon">
                        <DynamicSvg :name="getIconName()" />
                    </div>
                    <div>
                        {{ getTitle() }}
                    </div>
                </div>
                <div class="plan-select-options" v-if="!isAppsumo()">
                    <div class="plan-select-option">
                        <PlanPeriods v-model="localPeriod" :current-plans="filteredCurrentPlans" />
                        <div v-if="COUNTABLE_PLAN_TYPES.includes(type)">
                            <Counter v-model="details[counter[type]]" :type="type" />
                        </div>
                        <div
                            class="plan-select-option"
                            v-if="
                                !trialInfo.trial &&
                                type === 'chatbot' &&
                                currentPlan
                            "
                        >
                            <div
                                class="extra-package"
                                v-if="type === 'chatbot'"
                                @click="chatbotExtraPackageModal = true"
                            >
                                <div class="material-icons">cake</div>
                                {{ $t("billing.extraPackage") }}
                            </div>
                        </div>
                    </div>
                    <div class="plan-drag">
                        <div class="plan-drag-basic" @click="previousPlan" v-if="prevButton">
                            <div class="material-icons">arrow_back</div>
                        </div>
                        <div class="plan-drag-basic" @click="nextPlan" v-if="nextButton">
                            <div class="material-icons">arrow_forward</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="supsis-plans" ref="supsisPlans">
                    <Card
                        v-if="teamGroupPlan"
                        :plan="teamGroupPlan"
                        :is-admin="isAdmin"
                        :is-group-plan="true"
                        class="plan"
                    />
                    <Card
                        v-for="(plan, index) of customerPlans"
                        :key="plan._id"
                        :plan="plan"
                        :period="localPeriod"
                        :details="details"
                        :appsumo-coupons="appsumoCoupons"
                        :plans="allLocalPlans"
                        :current-plans="localCurrentPlans"
                        :is-admin="isAdmin"
                        @subscribe="onSubscribe"
                        @unsubscribe="onUnSubscribe"
                        class="plan"
                    />
                </div>
            </div>
        </div>
    </a-spin>
</template>
<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import Card from "../../../../../components/billing/Card.vue";
import ChangePlan from "../../../../../components/billing/new/ChangePlan.vue";
import CancelPlanModal from "../../../../../components/billing/CancelPlanModal.vue";
import CreatePlanModal from "../../../../../components/billing/CreatePlanModal.vue";
import CreditCardNeeded from "../../../../../components/billing/CreditCardNeeded.vue";
import DowngradeWarn from "../../../../../components/DowngradeWarn.vue";
import moment from "moment";
import SupsisButton from "../../../../../components/common/SupsisButtonOld.vue";
import ExtraPlanModal from "../../../../../components/billing/ExtraPlanModal.vue";
import Header from "../../../../../components/Header.vue";
import Counter from "./Counter.vue";
import PlanPeriods from "./Period.vue";
import DynamicSvg from "../../../../../components/DynamicSvg.vue";
import { COUNTABLE_PLAN_TYPES } from "../../utils/util";
export default {
    name: "CustomerPlans",
    components: {
        DynamicSvg,
        PlanPeriods,
        Counter,
        Header,
        Card,
        CancelPlanModal,
        CreatePlanModal,
        ChangePlan,
        DowngradeWarn,
        CreditCardNeeded,
        SupsisButton,
        ExtraPlanModal,
    },
    props: {
        isAdmin: {
            type: Boolean,
            default: false,
        },
        siteId: {
            type: String,
            default: null,
        },
        siteAppsumoCoupons: {
            type: Array,
            default: () => [],
        },
        sitePlans: {
            type: Array,
            default: () => [],
        },
        siteCurrentPlans: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => {
        return {
            COUNTABLE_PLAN_TYPES,
            localPeriod: "monthly",
            cancelPlanModal: false,
            subscribePlanModal: false,
            chatbotExtraPackageModal: false,
            details: {
                agentCount: 1,
                whatsappChannel: 1,
                messengerChannel: 1,
                instagramChannel: 1,
                trendyolChannel: 1,
                metaLeadChannel: 1,
                linkedinChannel: 1,
                telegramChannel: 1,
                channelCount: 1,
            },
            showWarn: null,
            creditCardRequired: false,
            localType: null,
            localPlans: [],
            allLocalPlans: [],
            localCurrentPlans: [],
            appsumoCoupons: [],
            currentPlan: null,
            loading: true,
            teamGroupPlan: null,
            listener: null,
            prevButton: false,
            nextButton: true,
            counter: {
                supsis: "agentCount",
                whatsapp: "whatsappChannel",
                "whatsapp-business": "whatsappChannel",
                instagram: "instagramChannel",
                messenger: "messengerChannel",
                trendyol: "trendyolChannel",
                "meta-lead": "metaLeadChannel",
                linkedin: "linkedinChannel",
                telegram: "telegramChannel",
                webphone: "channelCount",
            },
            icons: {
                whatsapp: "CWhatsapp",
                "whatsapp-business": "WhatsappBusinessNew",
                supsis: "CSupsis",
                chatbot: "ChatbotNew",
                instagram: "CInstagram",
                telegram: "TelegramEntegration",
                custom: "CSupsis",
                appsumo: "AppSumo",
                messenger: "Messenger",
                trendyol: "trendyol",
                "meta-lead": "MetaIcon",
                "customer-tables": "CustomerTables",
                form: "Form",
                automation: "Automation",
                mail: "Mail",
                tasks: "Tasks",
                webhook: "WebhookIntegration",
                linkedin: "LinkedinEntegration",
                "voice-agent": "CAiVoice",
                webphone: "WebphoneIcon",
            },
        };
    },
    mounted() {
        this.initData();
        const supsisPlans = this.$refs.supsisPlans;
        this.listener = (e) => {
            const target = e.target;
            if (target.scrollLeft <= 100) {
                this.prevButton = false;
                this.nextButton = true;
            } else if (target.scrollLeft + 0.5 >= target.scrollWidth - target.clientWidth) {
                this.nextButton = false;
                this.prevButton = true;
            } else {
                this.prevButton = true;
                this.nextButton = true;
            }
        };
        if (supsisPlans) supsisPlans.addEventListener("scroll", this.listener);
    },
    beforeDestroy() {
        const supsisPlans = this.$refs.supsisPlans;
        supsisPlans.removeEventListener("scroll", this.listener);
    },
    methods: {
        ...mapActions({
            subscribePlan: "site/subscribePlan",
            unsubscribePlan: "site/unsubscribePlan",
            extraSubscription: "site/extraSubscription",
            updateSiteData: "site/updateSiteData",
            listChannels: "channel/listChannels",
        }),
        getTitle() {
            const title = (this.type || "")
                .split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
            const i18nKey = `message.plans.types.${(this.type || "").replace("-", "_")}`;
            return this.$t(i18nKey) === i18nKey ? title : this.$t(i18nKey);
        },
        getIconName() {
            return this.icons[this.type] || this.icons.supsis;
        },
        nextPlan() {
            const element = document.querySelector(".supsis-plans");
            element.scrollBy(700, 0);
        },
        previousPlan() {
            const element = document.querySelector(".supsis-plans");
            element.scrollBy(-700, 0);
        },
        async initData() {
            this.teamGroupPlan = null;
            this.localType = this.type;
            let plans = _.cloneDeep(this.plans);
            let allPlans = _.cloneDeep(this.plans);
            let currentPlans = _.cloneDeep(this.currentPlans) || [];
            let appsumoCoupons = _.cloneDeep(this.site.appsumoCoupons) || [];
            let period = this.localPeriod;
            let details = _.cloneDeep(this.details);
            if (this.isAdmin) {
                allPlans = this.sitePlans;
                plans = this.sitePlans;
                currentPlans = this.siteCurrentPlans || [];
                appsumoCoupons = this.siteAppsumoCoupons || [];
            }

            this.currentPlan = currentPlans.find((plan) => plan.planType === this.type) || null;
            this.appsumoCoupons = appsumoCoupons;
            if (this.currentPlan) {
              period = this.currentPlan.period;
              details = _.cloneDeep(this.currentPlan.details);
            }

            this.details = details;
            this.localPeriod = period;
            this.localCurrentPlans = currentPlans;
            this.allLocalPlans = allPlans;

            const parentType = (this.type || "").replace("-team", "");
            const isGroupPlans = (this.type || "").endsWith("team");
            if (!this.isAdmin && !isGroupPlans) {
                const teamPlan = plans.find((plan) => plan.type === parentType && plan.isTeamPlan);
                if (teamPlan) {
                    let altTitle = "";
                    if (teamPlan.type === "supsis") {
                        altTitle = this.$t("billing.teamPackage");
                    } else {
                        altTitle = this.$t("billing.adventPackage");
                    }
                    this.teamGroupPlan = {
                        type: this.localType,
                        title: teamPlan.title,
                        altTitle: altTitle,
                        isPopular: true,
                        features: [],
                    };
                    plans = plans.filter((plan) => !plan.isTeamPlan);
                }
            }

            if (parentType && isGroupPlans) {
                this.localPlans = plans.filter((plan) => plan.type === parentType && plan.isTeamPlan);
            } else {
                this.localPlans = plans.filter((plan) => (plan.dynamicType || plan.type) === this.type);
            }
            this.loading = false;
        },
        onSubscribe(payload) {
            if (payload.couponCode) {
                this.subscribe(payload);
            } else {
                this.subscribePlanModal = payload;
            }
        },
        onUnSubscribe(payload) {
            this.cancelPlanModal = payload;
        },
        subscribe(payload) {
            if (
                this.sitePaymentMethod === "credit-card" &&
                (!this.billingDetail || !this.billingDetail.binNumber) &&
                this.trialInfo.remainingDays <= 0 &&
                !payload.isFreePlan &&
                !this.isAdmin
            ) {
                this.creditCardRequired = true;
                return;
            }
            this.subscribePlanModal = null;

            this.subscribePlan({
                siteId: this.siteId,
                ...payload,
            })
                .then((action) => {
                    if (action.status === "error") {
                        if (action.message === "PLAN_ALREADY_ACTIVE") {
                            this.$notification.error({
                                description: "Bu aboneliğiniz zaten aktif.",
                            });
                            return;
                        }
                        this.$notification.error({
                            message: "Kart Hatası",
                            description: action.message,
                        });
                        return;
                    }

                    if (!action || !action.planType) {
                        if (!action.isValid && payload.couponCode) {
                            this.$toasted.error(this.$t("billing.cupponError"), {
                                duration: 3000,
                                position: "top-center",
                            });
                            return;
                        }

                        this.$toasted.error(
                            !this.billingDetail || !this.billingDetail.binNumber
                                ? this.$t("billing.enterYourCard")
                                : this.$t("billing.invalidCard"),
                            {
                                duration: 3000,
                                position: "top-center",
                            }
                        );

                        return;
                    }
                    if (payload.couponCode) {
                        this.updateSiteData({
                            appsumoCoupons: [
                                ...this.appsumoCoupons,
                                {
                                    code: payload.couponCode,
                                },
                            ],
                        });
                        this.$toasted.success(this.$t("auto.billingCouponAppliedSuccess"), {
                            duration: 3000,
                            position: "top-center",
                        });
                    }
                    this.$router.go(-1);
                    this.$notification.success({
                        message: this.$t("billing.subStart"),
                        description: this.$t("billing.subSuccessStart"),
                    });
                })
                .catch(() => {
                    this.$notification.error({
                        message: "Başarısız",
                        description: "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
                    });
                })
        },
        forwardPage() {
            if (this.showWarn === "supsis") this.$router.push("/users");
            if (this.showWarn === "whatsapp") this.$router.push("/integrations/whatsapp-v1");
            if (this.showWarn === "whatsapp-business") this.$router.push("/integrations/whatsapp-business-api");
        },
        unsubscribe(payload) {
            this.unsubscribePlan({ siteId: this.siteId, ...payload }).then(() => {
                this.cancelPlanModal = false;
                this.$router.push("/settings/billing");
                if (this.type === "whatsapp-voice-call"){
                    this.listChannels();
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 100);
                }
                this.$notification.success({
                    message: "Başarılı",
                    description: "Aboneliğiniz iptal edildi.",
                });
            });
        },
        goBack() {
            this.$emit("go-back");
        },
        subscribeExtra(sessionCount) {
            this.extraSubscription({
                planType: this.$route.params.type,
                subscription: {
                    sessionCount,
                },
            }).then((plan) => {
                if(plan.status === "error") {
                    this.$notification.error({
                        message: "Başarısız",
                        description: plan.message,
                    });
                } else {
                    this.$notification.success({
                        message: this.$t("billing.success"),
                        description: this.$t("billing.successDesc"),
                    });
                }
            });
            this.chatbotExtraPackageModal = false;
        },
        isAppsumo() {
            return this.localPlans.find((plan) => plan.isAppsumo);
        },
    },
    computed: {
        ...mapState({
            loadingSubscribe: (state) => state.site.loadingSubscribe,
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            currentPlans: (state) => state.site.currentPlans,
            plans: (state) => state.site.plans,
            channels: (state) =>
                state.channel.channels.filter(
                    (x) => x.type === "whatsapp-v1" || x.type === "whatsapp-qr" || x.type === "whatsapp-v2"
                ),
            businessChannels: (state) => state.channel.channels.filter((x) => ["whatsapp-business-api", "whatsapp-business-api-supsis"].includes(x.type)),
            users: (state) => state.user.users.data.filter((user) => user.enable),
            billingDetail: (state) => state.site.billingDetail,
            sitePaymentMethod: (state) => state.site.site?.paymentMethod || "credit-card",
            trialInfo: (state) => {
                const site = state.site.site;
                if (site) {
                    const { createdAt } = site;
                    const diff = Math.ceil(moment().diff(moment(createdAt), "days", true));
                    const tookDays = Math.max(diff, 0);
                    const isTrial = tookDays <= _.get(state.setting.settings, "plan.trialDays");
                    return {
                        trial: isTrial,
                        remainingDays: isTrial ? _.get(state.setting.settings, "plan.trialDays") - tookDays : 0,
                    };
                } else {
                    return { trial: false, remainingDays: 0 };
                }
            },
            customerPlans() {
                const localPlans = [...this.localPlans];
                const plans = localPlans.filter((plan) => {
                    const isFreePlan = plan.isFreePlan;
                    const isMonthly = this.localPeriod === "monthly";
                    const isSupsisPlan = plan.type === "supsis";
                    const planFeatures = plan?.selectFeatures || [];
                    if (!isMonthly && planFeatures.length > 0) {
                        plan.selectFeatures = planFeatures.map((feature) => {
                          const price = feature.isTrialFeature ? feature.orjinalPrice : feature.price;
                          return {
                            ...feature,
                            isDisabled: price === 0,
                          };
                        });
                    }
                    return !isMonthly || (isSupsisPlan && this.details.agentCount > 1) ? !isFreePlan : true;
                });
                const enterprisePlan = plans.filter((plan) => plan.isEnterPrise);
                return [...plans.filter((plan) => !plan.isEnterPrise), ...enterprisePlan];
            },
            /**
             * Sadece bu plan tipine ait aktif planları filtreler
             * Period component'ine göndermek için
             */
            filteredCurrentPlans() {
                const currentPlans = this.localCurrentPlans || [];
                return currentPlans.filter(cp => cp.planType === this.type);
            },
        }),
    },
    watch: {
        currentPlans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        plans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        type: {
            handler() {
                if (this.type !== this.localType) {
                    this.localType = this.type;
                    this.localPeriod = "monthly";
                }
                this.initData();
            },
        },
    },
};
</script>
<style lang="scss">
.billing-plans {
    padding: 30px 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .plan-select-options {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;

        .plan-select-option {
            display: flex;
            align-items: center !important;
            gap: 30px;
        }

        .plan-drag {
            display: flex;
            align-items: center;
            gap: 5px;

            .plan-drag-basic {
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #f1f4f7;
                border-radius: 4px;

                .material-icons {
                    color: #8796af;
                }

                &:hover {
                    .material-icons {
                        color: rgb(236, 75, 29);
                    }
                }
            }
        }
    }

    .extra-package {
        width: 150px;
        background-color: rgb(236, 75, 29) !important;
        color: white !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 40px;
        font-size: 14px;
        height: 40px;
        cursor: pointer;
        gap: 5px;

        .material-icons {
            font-size: 18px;
        }

        &:hover {
            -webkit-box-shadow: 0px 0px 28px -10px rgb(236, 75, 29);
            -moz-box-shadow: 0px 0px 28px -10px rgb(236, 75, 29);
            box-shadow: 0px 0px 28px -10px rgb(236, 75, 29);
        }
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        color: black;
        display: flex;
        flex-direction: column;
        gap: 35px;

        &-plan {
            display: flex;
            align-items: center;
            gap: 10px;

            &-icon {
                width: 40px;
                height: 40px;

                svg {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .plan-select-options {
        display: flex;
        align-items: center;
    }

    .supsis-slider {
        .ant-slider-track,
        .ant-slider-rail {
            height: 8px !important;
        }

        .ant-slider-handle {
            width: 17px !important;
            height: 17px !important;
            margin-top: -4px !important;
        }
    }

    .content {
        overflow: hidden !important;
        border: none !important;
        min-height: auto !important;
        position: relative;

        .ant-slider-handle {
            background: rgb(236, 75, 29);
            border-color: rgb(236, 75, 29);

            :focus {
                box-shadow: none;
                -webkit-box-shadow: none;
            }
        }

        .ant-slider-track {
            background: rgb(236, 75, 29);
        }

        .supsis-plans {
            max-width: 90vw;
            display: flex;
            overflow: auto !important;
            gap: 28px;
            scroll-behavior: smooth;

            &::-webkit-scrollbar {
                display: none;
            }

            .plan {
                min-width: 18vw !important;
            }
        }

        .navigate-arrow {
            color: white !important;
            font-size: 24px !important;
            font-weight: 800 !important;
        }

        #prev-button {
            position: absolute;
            left: 15px;
            top: 50%;
            z-index: 99999;
            height: 60px;
            width: 60px;
            border-radius: 50%;
            background-color: rgb(236, 75, 29) !important;
            border: none;

            .navigate-left {
                margin-right: 2px !important;
            }
        }

        #next-button {
            position: absolute;
            right: 15px;
            top: 50%;
            z-index: 99999;
            height: 60px;
            width: 60px;
            border-radius: 50%;
            background-color: rgb(236, 75, 29) !important;
            border: none;

            .navigate-right {
                margin-left: 2px !important;
            }
        }
    }

    @keyframes scale-in {
        0% {
            transform: scale(0);
        }

        100% {
            transform: scale(1);
        }
    }

    @keyframes scale-out {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(0);
        }
    }

    .scale-in {
        animation: scale-in 0.3s forwards;
    }

    .scale-out {
        animation: scale-out 0.3s forwards;
    }
}
</style>
